import React from 'react';
import { Link } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import CarrouselProducts from 'components/commons/CarrouselProducts';
import MarketingNewsletter from 'components/commons/MarketingNewsletter';
import './HomeTextil.scss';

const HomeTextil = ({
  cartel,
  sliders,
  categoriesHome,
  mostSelled,
  featuredProducts,
  submitNewsletter,
  newsletter,
  setNewsletter,
  loadingNewsletter,
  client,
  renderItem
}) => {
  const redirectCartel = (numeroCartel) => {
    if(cartel[numeroCartel].subcategory_id !== null){
      return `/productos/${cartel[numeroCartel].category.code}/${cartel[numeroCartel].subcategory.code}`;
    }
    else{
      return `/productos/${cartel[numeroCartel].category.code}`;
    }
  }
  return (
    <div className="home home-textil">
      {/* Hero */}
      <div className="hero-image">
        <Carousel
          autoPlay
          infiniteLoop
          showThumbs={false}
          showStatus={false}
        >
          {sliders.map(({ id, image, isImage, text }) => (
            <div key={id}>
              {isImage ? (
                <img src={image} alt={text} />
              ) : (
                <video autoPlay muted loop>
                  <source src={image} type="video/mp4" />
                </video>
              )}
            </div>
          ))}
        </Carousel>
      </div>

      {/* Categorías */}
      <section className="categories-section">
        <h2 className="section-title">Nuestras Categorías</h2>
        <p className="section-subtitle">Descubre nuestra amplia selección de telas</p>
        <div className="categories-grid">
          {categoriesHome.slice(0, 4).map(({ category }) => (
            <Link
              key={category.id}
              to={`/productos/${category.code}`}
              className="category-card"
            >
              <img src={category.imageHome} alt={category.name} />
              <div className="card-overlay">
                <span>{category.name}</span>
                <button type="button">Ver más</button>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <div className='section'>
        {cartel[0] && (
          <div className="imgCartel-wrapper">
            <img 
              src={cartel[0].image} 
              alt="Banner" 
              className="imgCartel-full" 
            />
            <div className="infoCartel-overlay">
              <div className="description-container">
                <Link to={redirectCartel(0)}>
                  <button type="button">Ver Coleccion</button>
                </Link>
              </div>
            </div>
          </div>
        )}
        {cartel[1] && (
          <div className="imgCartel" style={{ backgroundImage: `url(${cartel[1].image})` }}>
            <div className="infoCartel">
              <div className="description-container row">
                <Link to={redirectCartel(1)}><button type="button">Ver Coleccion</button></Link>
              </div>
            </div>
          </div>
        )}
        {cartel[2] && (
          <div className="imgCartel" style={{ backgroundImage: `url(${cartel[2].image})` }}>
            <div className="infoCartel">
              <div className="description-container row">
                <Link to={redirectCartel(2)}><button type="button">Ver Coleccion</button></Link>
              </div>
            </div>
          </div>
        )}
        {cartel[3] && (
          <div className="imgCartel" style={{ backgroundImage: `url(${cartel[3].image})` }}>
            <div className="infoCartel">
              <div className="description-container row">
                <Link to={redirectCartel(3)}><button type="button">Ver Coleccion</button></Link>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Más vendidos */}
      <section className="favorites-section">
        <span className="badge-small">⭐ MÁS VENDIDOS</span>
        <h2 className="section-title">Favoritos de Nuestros Clientes</h2>
        <p className="section-subtitle">Calidad y versatilidad</p>
        <div className="product-list">
          {mostSelled.map(renderItem)}
        </div>
      </section>

      {/* Destacados */}
      <section className="featured-section">
        <h2 className="section-title">Productos Destacados</h2>
        <p className="section-subtitle">Los más vendidos con los mejores precios</p>
        <div className="product-list">
          {featuredProducts.map(renderItem)}
        </div>
      </section>
      <MarketingNewsletter
        email={newsletter}
        onEmailChange={setNewsletter}
        onSubmit={submitNewsletter}
        loading={loadingNewsletter}
        clientName={client?.name_show || client?.name}
        variant="textil"
      />
    </div>
  )
};

export default HomeTextil;
